import React from 'react';
import { useIntl } from 'react-intl';
// Core
import { Grid, Box } from '@mui/material';
// Components
import { Checkbox } from 'Components';
// Utilities
import {
  getFeatureDisplayCode,
  isParentEnabled,
  disableChildModules,
} from '../modules/hierarchicalFeatures';

/**
 * Local permissions of a module where any number of subModules can be selected
 * (one checkbox per subModule, grouped by groupName).
 */
const MultipleSubModules = ({ localPermissions, globalPermission, onChange }) => {
  const { messages } = useIntl();

  // Flat list of all subModules for hierarchical checks
  const allSubModules = localPermissions.flatMap((lp) => lp.subModules);

  const handleChange = (checked, indexSection, indexSubModule, subModule) => {
    // Deep copy so React detects the state change
    const newLocalPermissions = localPermissions.map((section, sIdx) => ({
      ...section,
      subModules: section.subModules.map((sm, smIdx) => {
        if (sIdx === indexSection && smIdx === indexSubModule) {
          return { ...sm, checked };
        }
        return { ...sm };
      }),
    }));

    // If unchecking, also disable any child subModules that depend on this one
    if (!checked) {
      disableChildModules(subModule, newLocalPermissions.flatMap((lp) => lp.subModules));
    }

    onChange(newLocalPermissions);
  };

  return (
    <Grid item sm={12}>
      <label className="title-permission">{messages['role_localAccess']}</label>
      {localPermissions.map((item, indexSection) => (
        <Grid key={`section-local-permissions-${indexSection}`} item sm={12}>
          <Grid item sm={12}>
            <Box mt={2} mb={1}>
              <label>{messages[`role_${item.groupName}`] ?? item.groupName}</label>
            </Box>
          </Grid>
          {item.subModules.map((subModule, indexSubModule) => {
            const parentEnabled = isParentEnabled(subModule, allSubModules);
            const isDisabled = !globalPermission?.checked || !parentEnabled;

            return (
              <Grid key={`local-permissions-${indexSubModule}`} item sm={12}>
                <Checkbox
                  value={subModule.checked}
                  onChange={(checked) => handleChange(checked, indexSection, indexSubModule, subModule)}
                  size="small"
                  id={`permission-${subModule.code}`}
                  label={
                    messages[`role_${globalPermission.code}_${subModule.name === 'Tags' ? subModule.name : getFeatureDisplayCode(subModule.code)}`] ||
                    subModule.name
                  }
                  disabled={isDisabled}
                />
              </Grid>
            );
          })}
        </Grid>
      ))}
    </Grid>
  );
};

export default MultipleSubModules;
